import { BaseHTMLElement, customElement } from 'dom-native';

import type { ToastMessage } from '@/types/chat';

function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

@customElement('help-agent-toast-stack')
export class HelpAgentToastStack extends BaseHTMLElement {
  private _toasts: ToastMessage[] = [];

  init(): void {
    super.init();
    this.render();
  }

  setToasts(toasts: ToastMessage[]): void {
    this._toasts = [...toasts];
    if (this.initialized) {
      this.render();
    }
  }

  private render(): void {
    this.innerHTML = `
      <div class="help-agent-toast-stack-shell" aria-live="polite" aria-atomic="true">
        ${this._toasts.map((toast) => `
        <div class="help-agent-toast is-${toast.type}">
            <span class="help-agent-toast-message">${escapeHtml(toast.message)}</span>
          </div>
        `).join('')}
      </div>
    `;
  }
}
